import { trialExtensionReasons, } from "@zapier/upsells/esm/types";
export const canExtendTrial = ({ currentPlanAmount, enabledTrialExtensions, reason, isTrialingCompanies, isTrialingProfessional, isTrialingTeams, }) => {
    const reasonIsEligibleForTrialExtension = Object.values(trialExtensionReasons).includes(reason);
    const accountIsEligibleForTrialExtension = !isTrialingProfessional &&
        !isTrialingTeams &&
        !isTrialingCompanies &&
        currentPlanAmount === 0 &&
        !(enabledTrialExtensions !== null && enabledTrialExtensions !== void 0 ? enabledTrialExtensions : []).includes(reason);
    return (reasonIsEligibleForTrialExtension && accountIsEligibleForTrialExtension);
};

// @zapier/upsells@8.0.1 (466b4077f)
